// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=dafdbdbb-9aae-4cbd-beea-a6e3c1ea1c82";
};